import { useState, useEffect } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { GetDescription } from '../../Components/Public/Functions/GetDescription.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { BlockLogoFestival } from '../../Components/Public/Logos/BlockLogoFestival.js';
import { BlockTitleDate1Link0 } from '../../Components/Public/Blocks/BlockTitleDate1Link0.js';
import { BlockOutlink } from '../../Components/Public/Blocks/BlockOutlink.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';

export const Festivals = (props) => {
    const { navParks } = props;
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [attraction, setAttraction] = useState([]);
    const [body, setBody] = useState([]);
    const id = 14; // category parade
    useEffect(() => {
        const fetchtheData = async () => {
            const dataAttraction = await fetch(`${backend}/attractions_by_festival?id=${id}`, GetHeaders(guest));
            const attraction = await dataAttraction.json();
            setAttraction(attraction);
            const dataBody = await fetch(`${backend}/festival/body`, GetHeaders(guest));
            const body = await dataBody.json();
            setBody(body);
        };
        fetchtheData();
        ScrollTop();
    }, [backend, guest]);
    const items = GetDescription('festival', { body: body, attraction: attraction });
    return (
        <div className="festival">
            <Navigation navParks={navParks} />
            <Header />
            <BreadCrumb label="festivals" />
            <section className="infos">
                <div className="list">
                    {attraction.map((item, i) => {
                        return (
                            <BlockLogoFestival item={item} key={i} />
                        )
                    })}
                </div>
                <div className="description">
                    <BlockTitleDate1Link0 label="festivals" items={items} />
                    <p>{items.description}</p>
                    <BlockOutlink items={items} />
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}